// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9e510ef8","933":"ea8569ae"}[chunkId] + ".chunk.css";
};